import { Injectable, inject } from '@angular/core';
import { GroupOrderTypesService } from '../services/group-order-types/group-order-types.service';

/**
 * Resolver to fetch all group order types
 */
@Injectable()
export class GroupOrderTypesResolver {
  private readonly groupOrderTypeService = inject(GroupOrderTypesService);


  resolve() {
    return this.groupOrderTypeService.getGroupTypes();
  }
}
